import type { FC, PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';

import { swrConfig } from '~/constants';

export const ApiProvider: FC<PropsWithChildren> = ({ children }) => (
  <SWRConfig value={swrConfig}>{children}</SWRConfig>
);
